import { httpClient } from '../../services/http-client'

class CodePackagesApi {
    all() {
        return httpClient
            .get(`/codepackages`)
            .then(res => {
                return res.data
            })
    }

    onlyPublic(flexible: boolean = false) {
        const url = flexible
            ? '/codepackages?flexible=true&onlyPublic=true'
            : '/codepackages?onlyPublic=true'

        return httpClient.get(url)
            .then(res => res.data)
    }

    get(name: string, flexible: boolean = false) {
        const url = flexible
            ? `/codepackages/flexible/${name}`
            : `/codepackages/${name}`

        return httpClient.get(url)
            .then(res => res.data)
    }
}

export const codePackagesApi = new CodePackagesApi()
